import { createReducer, on } from '@ngrx/store';
import { immerOn } from 'ngrx-immer/store';
import { __clearExperiences, __updateExperiences } from './experiences.actions';

const initialState: any = null;

export const experiencesReducer = createReducer(
    initialState,
    immerOn(__updateExperiences, (state, newState) => {
        return newState;
    }),
    immerOn(__clearExperiences, (state, newState) => {
        return newState;
    }),
)